import React, { useState, useEffect } from 'react';
import './MainEnSensor.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import useIsMobile from '../../hooks/useIsMobile';
import { fetchEv_list, addEv, removeEv } from '../../store';


import SunSensorIcon from '../../image/icons/solar-panel.png'; // Import the image
import SunTempIcon from '../../image/icons/high-temperature.png'; // Import the image

import { useSelector, useDispatch  } from 'react-redux';




function MainEnSensor({  TopTitle }){
  const dispatch = useDispatch();
  const Ev_list = useSelector((state) => state.Ev_list || {});
  const evData = useSelector((state) => state.evData || {});
  const [xsun, setXsun] = useState(null);
  const [ysun, setYsun] = useState(null);
  const [tempAir, setTempAir] = useState(null);
  const [tempSurface, setTempSurface] = useState(null);
  const isMobile = useIsMobile();

  useEffect(() => {
      dispatch(fetchEv_list());
    }, [dispatch]);
  

  // evData가 업데이트될 때마다 값을 설정하는 useEffect
  useEffect(() => {
    const seqLength = evData.seq?.length || 0;

    if (seqLength === 1) {
      // 장비가 1개일 때 (인덱스 0만 처리)
      const tempType = Ev_list.ev_temperatureType?.[0];
      const sunType = Ev_list.ev_sunType?.[0];

      if (sunType === 0) {
        setYsun(evData.sun[0]);
      } else {
        setXsun(evData.sun[0]);
      }

      if (tempType === 0) {
        setTempSurface(evData.temperature[0]);
      } else {
        setTempAir(evData.temperature[0]);
      }
    }

    if (seqLength === 2) {
      // 장비가 2개일 때 (인덱스 0, 1 모두 처리)
      for (let i = 0; i < 2; i++) {
        const tempType = Ev_list.ev_temperatureType?.[i];
        const sunType = Ev_list.ev_sunType?.[i];

        if (sunType === 0) {
          setXsun(evData.sun[i]);
        } else {
          setYsun(evData.sun[i]);
        }

        if (tempType === 0) {
          setTempSurface(evData.temperature[i]);
        } else {
          setTempAir(evData.temperature[i]);
        }
      }
    }
  }, [evData, Ev_list]);

  
  return (
    <>
        <div className='Ensensor-container'>
          {/* 센서 상단 박스 (타이틀 및 옵션 버튼) */}
          <div className='Ensensor-topbox' style={{ border: 'none', borderBottom: '2px solid #DCE0EB' }}>
            {/* 센서 제목 */}
            <div>{'◎ '+ TopTitle}</div>
            <div style={{ flexGrow: '1' }}></div>{/* 빈 공간을 확보하여 오른쪽 정렬 유도 */}
            <div>⦁ ⦁ ⦁</div>
          </div>
          {/* 센서 데이터 박스 */}
          <div className='Ensensor-midbox' >
            <Container className='text-EnSensorlist-ColStyle_custom'>

              {/* 일사량 정보 영역 */}
              <Row className='text-EnSensorlist-custom align-items-center' style={{borderBottom:'#D3E1F0 solid 1px', paddingLeft:'5px'}}>
                <Col xs={12}><img src={SunSensorIcon} width="70" height="70"></img></Col>
                <Col xs={1}></Col>
                <Col xs={11} className='text-EnSensorlist-detail' style={{ flex: '0 0 115px',  fontSize: isMobile ? "18px" : "21px"}}>
                  <Row  style={{borderBottom:'#D3E1F0 solid 1px'}} >경사 일사량</Row>
                  <Row>수평 일사량</Row>
                </Col>

                <Col className='text-EnSensorlist-detail' style={{ flex:'0 0 30px', fontSize: isMobile ? "x-large" : "xx-large", color:'#47DDC9'}}>
                    <Row style={{ display: 'block', textAlign: 'center',borderBottom:'#D3E1F0 solid 1px' }}>{xsun}</Row>
                    <Row style={{ display: 'block', textAlign: 'center' }}>{ysun}</Row>
                </Col>
                
                <Col className='text-EnSensorlist-detail' style={{ flex: '0 0 45px', fontSize:'large', color:'#47DDC9'}}>
                    <Row>W/㎡</Row>
                </Col>

              </Row>
              {/* 온도 센서 정보 영역 */}
              <Row className='text-EnSensorlist-custom align-items-center' >
                <Col xs = {12}><img src={SunTempIcon} width="70" height="70"></img></Col>
                <Col xs={1}></Col>
                <Col xs={11} className='text-EnSensorlist-detail' style={{ flex: '0 0 120px', fontSize: isMobile ? "18px" : "21px"}}>
                  <Row  style={{borderBottom:'#D3E1F0 solid 1px'}} >표면 온도</Row>
                  <Row>외기 온도</Row>
                </Col>

                <Col className='text-EnSensorlist-detail' style={{ flex:'0 0 30px', fontSize: isMobile ? "x-large" : "xx-large", color:'#47DD8E'}}>
                    <Row style={{ display: 'block', textAlign: 'center', borderBottom:'#D3E1F0 solid 1px'}}>{(tempSurface/10).toFixed(1)}</Row>
                    <Row style={{ display: 'block', textAlign: 'center' }}>{(tempAir/10).toFixed(1)}</Row>
                </Col>
                <Col className='text-EnSensorlist-detail' style={{ flex: '0 0 30px', color:'#47DD8E'}}>
                    <Row>℃</Row>
                </Col>

              </Row>
            </Container>
          </div>
        </div>
      </>
  );
}

export default MainEnSensor;
